import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions, RequestMethod } from "@angular/http";
import { CookieService } from "ngx-cookie-service";
import { AppCommonService } from "../appcommon.service";
import { AuthService } from "../auth.service";
import { GlobalService } from "../global.service";
import { ApiEndPoints } from "../api.endpoints";
import { Observable } from "rxjs/Observable";
import { ILoggedUser, LoggedUserModel } from "./loggeduser/loggeduser";
import { IAccount, AccountAccessModel } from "./accounts/account";
import { Contact } from "./contact/contact";
import { SendEnquiry } from "./loggeduser/sendenquiry";
import { ForgottenPassword, ForgotPasswordModel } from "./forgottenpassword/forgottenpassword";
import { ResetPassword, ResetPasswordModel } from "./resetpassword/resetpassword";
import { Router } from "@angular/router";
import { Register } from "./register/register";

@Injectable()
export class HeaderAndNavigationService extends GlobalService {
  public showNonAccountNav: boolean = false;
  public showAccountNav: boolean = false;
  public userRoles: string[];
  mftAccessToken: string = "mftAccessToken";
  constructor(
    private http: Http,
    private cookieService: CookieService,
    private appCommonService: AppCommonService,
    private authService: AuthService,
    private router: Router
  ) {
    super(http, router);
    this.authServiceRef = this.authService;
  }

  public showhideNav(nonAccNav: boolean, accNav: boolean) {
    setTimeout(() => {
      this.showNonAccountNav = nonAccNav;
      this.showAccountNav = accNav;
    }, 0)
  }


  public callImperaonateAuthenticateToken(token: any,impersonateId:any) {
    //let callURL = 'https://myfleethub.staging.x-rm.com/connect/loginas?impersonatedUserId=' + impersonateId
      let callURL = ApiEndPoints.XRMLoginASUrl + impersonateId
    let headers: Headers = new Headers({
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${token}`,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(callURL, null , options)      
      .catch(this.handleError);
  }

    public updateUserInfoXRM(token: any) {
        //debugger;
    //let callURL = 'https://myfleethub.staging.x-rm.com/connect/userinfo'
      let callURL = ApiEndPoints.XRMUserInfo;

    let headers: Headers = new Headers({
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${token}`,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http.get(callURL,  options)
      .catch(this.handleError);
  }


  public getLoggedUserFromAPI(token: any): Observable<ILoggedUser> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let token = this.authService.getToken();
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UserEndPoint.replace('{userId}', token.userId);
      return this.http.get(url, options)
        .map(data => <ILoggedUser>data.json())
        .do(this.populateLoggerUserInfo)
        .catch(this.handleError);
    }
    else {
      //let token = this.authService.getToken();      
      let model = new LoggedUserModel();
     // model.EndPointURL = ApiEndPoints.UserEndPoint;
      model.UserId = token.userId;
      model.Token = token.access_token;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UserEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .do(this.populateLoggerUserInfo)
        .catch(this.handleError);
    }    
  }

  //public getLoggedUserFromAPI(): Promise<ILoggedUser> {
  //  if (ApiEndPoints.UseDirectEndPoint) {
  //    let token = this.authService.getToken();
  //    let headers = this.authService.GetAuthHeader();
  //    let options = new RequestOptions({ headers: headers });
  //    const url = ApiEndPoints.UserEndPoint.replace('{userId}', token.userId);
  //    return this.http.get(url, options)
  //      .toPromise()
  //      .then(this.extractData)
  //      .catch(this.handleError);
  //  }
  //  else {
  //    let token = this.authService.getToken();
  //    let model = new LoggedUserModel();
  //    model.EndPointURL = ApiEndPoints.UserEndPoint;
  //    model.UserId = token.userId;
  //    model.Token = token.access_token;
  //    let body = JSON.stringify(model);
  //    let headers: Headers = new Headers({
  //      'Content-Type': 'application/json; charset=utf-8'
  //    });
  //    let options = new RequestOptions({ headers: headers });
  //    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UserEndPointServer;
  //    return this.http.post(callURL, body, options)
  //      .toPromise()
  //      .then((response: Response) => <any>response.json())
  //      .catch(this.handleError);
  //  }
  //}

  public getLoggedUser(): ILoggedUser {
    return this.authService.getUser();;    
  }

  public populateLoggerUserInfo(loggeduser: ILoggedUser) {        
    loggeduser.name = loggeduser.firstName + " " + loggeduser.lastName;
    return loggeduser;
  }

  public getAccessAccounts(): Observable<IAccount[]> {
    let accesAccounts = this.authService.getAccessAccounts();
    if (accesAccounts.length > 0) {
      return Observable.of(accesAccounts)
    }
    let observableAccesAccounts = this.readAccessAccounts();
    observableAccesAccounts.subscribe(
      (accounts: IAccount[]) => {
        for (let account of accounts) {
          account.selected = false;
          account.ledger = account.ledger.split(" ")[0];
        }
        this.authService.setAccessAccounts(accounts)
      }
    );
    return observableAccesAccounts;
  }

  public readAccessAccounts(): Observable<IAccount[]> {
    
    if (ApiEndPoints.UseDirectEndPoint) {
      let token = this.authService.getToken();
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.AccountAccessEndPoint.replace('{userId}', token.userId);
      return this.http.get(url, options)
        .map(data => <IAccount[]>data.json())
        .catch(this.handleError);
    }
    else {
      let token = this.authService.getToken();
      let model = new AccountAccessModel();
      //model.EndPointURL = ApiEndPoints.AccountAccessEndPoint;
      model.UserId = token.userId;
      model.Token = token.access_token;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.AccountAccessEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }

  public checkRoleAccess(roles: string[]): boolean {
    this.userRoles = this.authService.getUserRoles();
    var avail: boolean = false;
    roles.forEach(item => {
      if (!avail) {
        var roles = this.userRoles.filter(x => x === item);
        if (roles.length > 0) {
          avail = true;
        }
        else {
          avail = false;
        }
      }
    });
    return avail;
  }

  public checkCO2Access(): boolean {    
    var avail: boolean = false;
    var accountList = this.authService.getAccessAccounts();
    var co2AccountList = accountList.filter(c => c.accountHasCO2CountEnabled == true);
    if (co2AccountList.length > 0) {
      avail = true;
    }
    else {
      avail = false;
    }
    return avail;
  }


  public callContact(model: Contact): Observable<Contact> {
    let body = JSON.stringify(model);
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    let options = new RequestOptions({ headers: this.authService.GetHeader() });
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CallContact;
    return this.http.post(callURL, body, options)
      // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
      .catch(this.handleError);
  }

  public callRegister(model: Register): Observable<Register> {
    let body = JSON.stringify(model);
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    let options = new RequestOptions({ headers: this.authService.GetHeader() });
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CallRegister;
    return this.http.post(callURL, body, options)
      // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
      .catch(this.handleError);
  }

  public sendEnquiry(model: SendEnquiry): Observable<SendEnquiry> {
    let body = JSON.stringify(model);
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    let options = new RequestOptions({ headers: this.authService.GetHeader() });
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.SendEnquiry;
    return this.http.post(callURL, body, options)
      // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
      .catch(this.handleError);
  }

  public sendUserPassword(forgotten: ForgottenPassword): Observable<ForgottenPassword> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let body = JSON.stringify(forgotten.username);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      return this.http.post(ApiEndPoints.ResetPasswordEndPoint, body, options)
        .map((response: Response) => {
          if (response.status === 200) {
          }
        })
        .catch(this.handleError);
    } else {
      let model = new ForgotPasswordModel();
      model.EndPointURL = ApiEndPoints.ResetPasswordEndPoint;
      model.username = forgotten.username;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.ResetPasswordEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }

  public newUserPassword(resetPassword: ResetPassword): Observable<ResetPassword> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let body = JSON.stringify(resetPassword);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      return this.http.put(ApiEndPoints.ResetPasswordEndPoint, body, options)
        .map((response: Response) => {
          if (response.status === 200) {
          }
        })
        .catch(this.handleError);
    }
    else {
      let model = new ResetPasswordModel();
      model.EndPointURL = ApiEndPoints.ResetPasswordEndPoint;
      model.ResetPassword = resetPassword;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.ResetPasswordEndPointPutServer;
      return this.http.put(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }

  public logOut(): void {    
    this.ClearUserData();
    this.router.navigate(['/']);
  }

  public ClearUserData() {
    //localStorage.clear();
    localStorage.removeItem(this.authService.mftAccessAccounts);
    localStorage.removeItem(this.authService.mftUserRoles);
    localStorage.removeItem(this.authService.mftUser);
    localStorage.removeItem(this.authService.mftForceChangePasswordFlag);
    localStorage.removeItem(this.authService.mftImpersonationId);
    localStorage.removeItem("mftAccessTokenLocalstorage");
    this.cookieService.delete(this.mftAccessToken, '/');
    sessionStorage.removeItem("userDataImpersonate_EServicesExternalLocalhost");
    sessionStorage.removeItem("userDataImpersonate_EServicesExternal");
    //this.cookieService.deleteAll('/');

    this.authService.removeAuthorization();
  }

  public RedirectToLogin(): void {
    this.ClearUserData();
    this.router.navigate(['/login']);
  }

  public RedirectToNoaccess(): void {
    this.ClearUserData();
    this.router.navigate(['/noacess']);
  }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/headerandnavigation.service.ts